import React from "react";
import styled from "styled-components";
import * as d3 from "d3";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import LaunchIcon from "@mui/icons-material/Launch";
import { RETURN_VIEW } from "./utils";

const WrapperWithTitle = styled.div`
  width: 100%;
  height: 100%;

  h3 {
    text-transform: none !important;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 12px !important;
    font-weight: 100;
    margin-top: 8px !important;
    cursor: pointer;

    svg {
      width: 11px;
      height: 11px;
      margin-left: 5px;
    }
  }
`;

const Wrapper = styled.div`
  display: flex;

  div.big-content {
    &:hover {
      cursor: pointer;
    }
    display: flex;
    font-family: "IBM Plex Mono", monospace !important;
    font-weight: normal;
    font-size: 24px !important;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    color: var(--text-primary) !important;
    span {
      font-weight: 100;
      font-size: 12px;
      margin-left: 5px;
      margin-top: 10px;
    }
    svg {
      height: 24px;
      width: 24px;
      margin-right: 0px;
    }
  }
  > div {
    width: 50%;
  }

  .sub-title {
    color: #6b7280;
    font-size: 12px;
    font-weight: 500;
  }
`;

const KppsRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  justify-content: flex-end;

  &:hover {
    cursor: pointer;
  }
`;

const Kpps = styled.div`
  font-size: 1.6rem !important;
  font-family: "IBM Plex Mono", monospace !important;
  font-weight: normal !important;
  color: var(--text-primary) !important;
  span {
    font-weight: 100;
    font-size: 1.3rem;
    margin-left: 8px;
  }
`;

function ThroughputValues({
  downRate = "n/a",
  upRate = "n/a",
  downPps,
  upPps,
  downPpsUnit,
  upPpsUnit,
}) {
  const [downRateValue, downRateUnit] = downRate.split(" ");
  const [upRateValue, upRateUnit] = upRate.split(" ");

  const renderValue = (value, unit, type) => {
    const isInvalid = !value || value === "n/a" || isNaN(value);
    if (isInvalid) {
      return "n/a";
    }
    return (
      <>
        {type === "down" ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />}
        {d3.format(".1f")(value)}
        {unit && <span>{unit}</span>}
      </>
    );
  };

  const renderValueKpps = (value, unit) => {
    const rate =
      isNaN(value) || value === null || value === "" ? 0 : Number(value);

    return (
      <>
        {d3.format(".1f")(rate)}
        {unit && <span>{unit}</span>}
      </>
    );
  };

  return (
    <WrapperWithTitle>
      <Wrapper>
        <div>
          <div
            className="big-content"
            onClick={() =>
              globalNavigate("viewSubscriberThroughput", {
                direction: "downlink",
                returnView: RETURN_VIEW,
              })
            }
          >
            {renderValue(downRateValue, downRateUnit, "down")}
          </div>
          <KppsRow
            onClick={() =>
              globalNavigate("viewBtaStatsTraffic", {
                returnView: RETURN_VIEW,
              })
            }
          >
            <Kpps>{renderValueKpps(downPps, downPpsUnit)}</Kpps>
          </KppsRow>
        </div>
        <div>
          <div
            className="big-content"
            onClick={() =>
              globalNavigate("viewSubscriberThroughput", {
                direction: "uplink",
                returnView: RETURN_VIEW,
              })
            }
          >
            {renderValue(upRateValue, upRateUnit, "up")}
          </div>
          <KppsRow
            onClick={() =>
              globalNavigate("viewBtaStatsTraffic", {
                returnView: RETURN_VIEW,
              })
            }
          >
            <Kpps>{renderValueKpps(upPps, upPpsUnit)}</Kpps>
          </KppsRow>
        </div>
      </Wrapper>
      <h3
        onClick={() =>
          globalNavigate("viewSubscriberThroughput", { returnView: RETURN_VIEW })
        }
      >
        Total Throughput <LaunchIcon />
      </h3>
    </WrapperWithTitle>
  );
}

export default ThroughputValues;
